import gql from 'graphql-tag';

const GET_ALL_REPLYTEMPLATES = gql`
  query {
    getReplyTemplates {
      id
      name
      content
      placeholdersUsed
      attachmentList {
        fileName
        originalFileName
        fileSize
      }
    }
  }
`;

const GET_NOTIFICATION_TEMPLATES = gql`
  query($notificationTemplateType: String!) {
    getNotificationTemplates(
      notificationTemplateType: $notificationTemplateType
    ) {
      id
      name
      subject
      content
      placeholdersUsed
      to {
        type
        user {
          userId
          email
          firstName
          lastName
          # forgotten
        }
        placeHolder
      }
      cc {
        type
        user {
          userId
          email
          firstName
          lastName
          # forgotten
        }
        placeHolder
      }
      bcc {
        type
        user {
          userId
          email
          firstName
          lastName
          # forgotten
        }
        placeHolder
      }
      activated
      # senderNameType
      # senderNameValue
      # emailSignatureType
      templateType
      templateSubtype
      attachmentList {
        fileName
        originalFileName
        fileSize
      }
      skipDomains
      skipEmails
      skipInitiatedByTechnician #AccountType
      defaultTemplate
    }
  }
`;

const GET_NOTIFICATION_TEMPLATES_INFO = gql`
  query($notificationTemplateType: String!) {
    getNotificationTemplateInfo(templateType: $notificationTemplateType) {
      id
      name
      templateType
      templateSubtype
      constant
      dataCondition
      templates {
        id
        name
        # templateType
        # templateSubtype
        # constant
        channel
        subject
        content
        placeholdersUsed
        to {
          type
          email
          group {
            groupId
            name
            description
          }
          user {
            userId
            email
            name
            # forgotten
          }
          userTypeRole {
            roleId
            name
          }
          placeHolder
        }
        cc {
          type
          email
          group {
            groupId
            name
            description
          }
          user {
            userId
            email
            name
            # forgotten
          }
          userTypeRole {
            roleId
            name
          }
          placeHolder
        }
        bcc {
          type
          email
          group {
            groupId
            name
            description
          }
          user {
            userId
            email
            name
            # forgotten
          }
          userTypeRole {
            roleId
            name
          }
          placeHolder
        }
        activated
        # senderNameType
        # senderNameValue
        # emailSignatureType
        templateType
        templateSubtype
        attachmentList {
          fileName
          originalFileName
          fileSize
        }
        skipDomains
        skipEmails
        skipInitiatedByTechnician #AccountType
        defaultTemplate
      }
    }
  }
`;

const GET_NOTIFICATION_TEMPLATEPLACEHOLDERS = gql`
  query {
    getNotificationTemplatePlaceholderFields {
      requesterFields
      technicianFields
      ticketFields
    }
  }
`;

const GET_NOTIFICATION_TEMPLATE_META_INFO = gql`
  query(
    $templateType: String!
    $templateSubtype: String
    $constant: String
    $channel: String
  ) {
    getNotificationTemplateMetaInfo(
      templateType: $templateType
      templateSubtype: $templateSubtype
      constant: $constant
      channel: $channel
    )
  }
`;

const GET_NOTIFICATION_TEMPLATE = gql`
  query($notificationTemplateType: String!, $templateId: ID!) {
    getNotificationTemplate(
      notificationTemplateType: $notificationTemplateType
      templateId: $templateId
    ) {
      id
      name
      defaultTemplate
      constant
      channel
      subject
      content
      placeholdersUsed
      to {
        type
        email
        group {
          groupId
          name
          description
        }
        user {
          userId
          email
          name
          # forgotten
        }
        userTypeRole {
          roleId
          name
        }
        placeHolder
      }
      cc {
        type
        email
        group {
          groupId
          name
          description
        }
        user {
          userId
          email
          name
          # forgotten
        }
        userTypeRole {
          roleId
          name
        }
        placeHolder
      }
      bcc {
        type
        email
        group {
          groupId
          name
          description
        }
        user {
          userId
          email
          name
          # forgotten
        }
        userTypeRole {
          roleId
          name
        }
        placeHolder
      }
      activated
      # senderNameType
      # senderNameValue
      # emailSignatureType
      templateType
      templateSubtype
      constant
      attachmentList {
        fileName
        originalFileName
        fileSize
      }
      canConfigureTo
      canConfigureCcAndBcc
      skipDomains
      skipEmails
      skipInitiatedByTechnician #AccountType
    }
  }
`;

const CREATE_REPLY_TEMPLATE = gql`
  mutation(
    $name: String
    $subject: String
    $content: String
    $placeholdersUsed: String
    # $senderNameType: SenderNameType
    # $senderNameValue: String
    # $emailSignatureType: EmailSignatureType
    $to: [RecipientInput]
    $cc: [RecipientInput]
    $bcc: [RecipientInput]
    $activated: Boolean
    $attachmentList: [NotificationTemplateAttachmentInput]
  ) {
    createReplyTemplate(
      input: {
        name: $name
        content: $content
        subject: $subject
        placeholdersUsed: $placeholdersUsed
        # senderNameType: $senderNameType
        # senderNameValue: $senderNameValue
        # emailSignatureType: $emailSignatureType
        to: $to
        cc: $cc
        bcc: $bcc
        activated: $activated
        attachmentList: $attachmentList
      }
    ) {
      name
      id
      content
      placeholdersUsed
    }
  }
`;

const CREATE_NOTIFICATION_TEMPLATE = gql`
  mutation(
    $notificationTemplateType: String!
    $name: String
    $subject: String
    $content: String
    $placeholdersUsed: String
    # $senderNameType: SenderNameType
    # $senderNameValue: String
    # $emailSignatureType: EmailSignatureType
    $to: [RecipientInput]
    $cc: [RecipientInput]
    $bcc: [RecipientInput]
    $activated: Boolean
    $attachmentList: [NotificationTemplateAttachmentInput]
    $skipInitiatedByTechnician: Boolean #AccountType
    $skipDomains: [String]
    $skipEmails: [String]
    $defaultTemplate: Boolean
  ) {
    createNotificationTemplate(
      notificationTemplateType: $notificationTemplateType
      input: {
        name: $name
        content: $content
        subject: $subject
        placeholdersUsed: $placeholdersUsed
        # senderNameType: $senderNameType
        # senderNameValue: $senderNameValue
        # emailSignatureType: $emailSignatureType
        to: $to
        cc: $cc
        bcc: $bcc
        activated: $activated
        attachmentList: $attachmentList
        skipInitiatedByTechnician: $skipInitiatedByTechnician
        skipDomains: $skipDomains
        skipEmails: $skipEmails
        defaultTemplate: $defaultTemplate
      }
    ) {
      name
      id
      content
      placeholdersUsed
      skipDomains
      skipEmails
      skipInitiatedByTechnician #AccountType
    }
  }
`;

const UPDATE_REPLY_TEMPLATE = gql`
  mutation(
    $templateId: ID!
    $name: String
    $content: String
    $subject: String
    $placeholdersUsed: String
    $attachmentList: [NotificationTemplateAttachmentInput]
  ) {
    updateReplyTemplate(
      templateId: $templateId
      input: {
        name: $name
        content: $content
        subject: $subject
        placeholdersUsed: $placeholdersUsed
        attachmentList: $attachmentList
      }
    ) {
      name
      id
      content
      placeholdersUsed
      attachmentList {
        fileName
        originalFileName
        fileSize
      }
    }
  }
`;

const UPDATE_NOTIFICATION_TEMPLATE = gql`
  mutation(
    $notificationTemplateType: String!
    $activated: Boolean
    $templateId: ID!
    $name: String
    $content: String
    $subject: String
    $placeholdersUsed: String
    $attachmentList: [NotificationTemplateAttachmentInput]
    $cc: [RecipientInput]
    $bcc: [RecipientInput]
    $to: [RecipientInput] # $senderNameType: SenderNameType # $senderNameValue: String # $emailSignatureType: EmailSignatureType
    $skipInitiatedByTechnician: Boolean #AccountType
    $skipDomains: [String]
    $skipEmails: [String]
    $defaultTemplate: Boolean
  ) {
    updateNotificationTemplate(
      notificationTemplateType: $notificationTemplateType
      templateId: $templateId
      input: {
        name: $name
        content: $content
        subject: $subject
        placeholdersUsed: $placeholdersUsed
        attachmentList: $attachmentList
        activated: $activated
        cc: $cc
        bcc: $bcc
        to: $to
        # senderNameType: $senderNameType
        # senderNameValue: $senderNameValue
        # emailSignatureType: $emailSignatureType
        skipInitiatedByTechnician: $skipInitiatedByTechnician
        skipDomains: $skipDomains
        skipEmails: $skipEmails
        defaultTemplate: $defaultTemplate
      }
    ) {
      name
      id
      content
      placeholdersUsed
      activated
      attachmentList {
        fileName
        originalFileName
        fileSize
      }
      cc {
        type
        user {
          userId
          email
          firstName
          lastName
          name
          # forgotten
        }
        placeHolder
      }
      to {
        type
        user {
          userId
          email
          firstName
          lastName
          name
          # forgotten
        }
      }
      bcc {
        type
        user {
          userId
          email
          firstName
          lastName
          name
          # forgotten
        }
      }
      # senderNameType
      # senderNameValue
      # emailSignatureType
      skipDomains
      skipEmails
      skipInitiatedByTechnician #AccountType
    }
  }
`;

const UPDATE_NOTIFICATION_TEMPLATE_INFO = gql`
  mutation(
    $activated: Boolean
    $templateId: ID!
    $notificationTemplateType: String!
  ) {
    updateNotificationTemplate(
      templateId: $templateId
      notificationTemplateType: $notificationTemplateType
      input: { activated: $activated }
    ) {
      activated
      channel
    }
  }
`;

const UPDATE_NOTIFICATION_TEMPLATE_INFO_API = gql`
  mutation($input: UpdateNotificationTemplateInfoInput!) {
    updateNotificationTemplateInfo(input: $input) {
      id
      name
      templateType
      templateSubtype
      constant
      templates {
        id
        name
      }
      dataCondition
    }
  }
`;

// enum AccountType {
//   MSP
//   CLIENT
// }

const DELETE_REPLY_TEMPLATE = gql`
  mutation($templateId: ID!) {
    deleteReplyTemplate(templateId: $templateId)
  }
`;

const DELETE_NOTIFICATION_TEMPLATE = gql`
  mutation($notificationTemplateType: String!, $templateId: ID!) {
    deleteNotificationTemplate(
      notificationTemplateType: $notificationTemplateType
      templateId: $templateId
    )
  }
`;

const CREATE_PROJECT_TEMPLATE = gql`
  mutation($input: CreateProjectTemplateInput!) {
    createProjectTemplate(input: $input) {
      templateId
      name
      description
      scheduledStartDate
      dueDate
      attachments {
        fileName
        originalFileName
        fileSize
        # applicable only for inline image upload like profile pic, logo, ...
        # downloadURL
      }
      milestones {
        milestoneId
        name
        tasks {
          taskTemplateId
          technician {
            userId
            name
            email
            firstName
            lastName
          }
          techGroup {
            name
            groupId
          }
          title
          description
          estimatedTime
          scheduledStartDate
          dueDate
        }
      }
      tasks {
        taskTemplateId
        technician {
          userId
          name
          email
          firstName
          lastName
        }
        techGroup {
          name
          groupId
        }
        title
        description
        estimatedTime
        scheduledStartDate
        dueDate
      }
    }
  }
`;

const UPDATE_PROJECT_TEMPLATE = gql`
  mutation($input: UpdateProjectTemplateInput!) {
    updateProjectTemplate(input: $input) {
      templateId
      name
      description
      scheduledStartDate
      dueDate
      attachments {
        fileName
        originalFileName
        fileSize
        # applicable only for inline image upload like profile pic, logo, ...
        # downloadURL
      }
      milestones {
        milestoneId
        name
        tasks {
          taskTemplateId
          technician {
            userId
            name
            email
            firstName
            lastName
          }
          techGroup {
            name
            groupId
          }
          title
          description
          estimatedTime
          scheduledStartDate
          dueDate
        }
      }
      tasks {
        taskTemplateId
        technician {
          userId
          name
          email
          firstName
          lastName
        }
        techGroup {
          name
          groupId
        }
        title
        description
        estimatedTime
        scheduledStartDate
        dueDate
      }
    }
  }
`;

const DELETE_PROJECT_TEMPLATE = gql`
  mutation($input: ProjectTemplateIdentifierInput!) {
    deleteProjectTemplate(input: $input)
  }
`;

export {
  UPDATE_REPLY_TEMPLATE,
  UPDATE_NOTIFICATION_TEMPLATE,
  UPDATE_NOTIFICATION_TEMPLATE_INFO,
  DELETE_REPLY_TEMPLATE,
  GET_NOTIFICATION_TEMPLATE,
  GET_NOTIFICATION_TEMPLATE_META_INFO,
  CREATE_REPLY_TEMPLATE,
  GET_ALL_REPLYTEMPLATES,
  GET_NOTIFICATION_TEMPLATEPLACEHOLDERS,
  CREATE_NOTIFICATION_TEMPLATE,
  GET_NOTIFICATION_TEMPLATES,
  GET_NOTIFICATION_TEMPLATES_INFO,
  DELETE_NOTIFICATION_TEMPLATE,
  CREATE_PROJECT_TEMPLATE,
  UPDATE_PROJECT_TEMPLATE,
  DELETE_PROJECT_TEMPLATE,
  UPDATE_NOTIFICATION_TEMPLATE_INFO_API
};
